// Module
var code = "{{^.visible}}display:none;{{/}}";
// Exports
export default code;